var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPendingReview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 7C23 10.3137 20.3137 13 17 13C13.6863 13 11 10.3137 11 7C11 3.68629 13.6863 1 17 1C20.3137 1 23 3.68629 23 7ZM16 3.27724C16 2.84798 16.3384 2.5 16.7557 2.5C17.1731 2.5 17.5115 2.84798 17.5115 3.27724V6.84147L19.7787 9.17318C20.0738 9.47671 20.0738 9.96882 19.7787 10.2724C19.4835 10.5759 19.005 10.5759 18.7099 10.2724L16 7.48535V3.27724ZM2 2H10.7546C10.2724 2.60158 9.87526 3.27434 9.58152 4H2V20H8V15C8 14.4477 8.44771 14 9 14H13.124C13.9942 14.4829 14.9639 14.8082 15.9946 14.9374C15.9507 15.6681 15.6408 16.3599 15.12 16.88L10.88 21.12C10.3179 21.6828 9.55538 21.9993 8.76 22H2C0.89543 22 0 21.1046 0 20V4C0 2.89543 0.89543 2 2 2ZM4.5 6H9.06189C9.02104 6.32759 9 6.66134 9 7C9 7.33866 9.02104 7.67241 9.06189 8H4.5C4.22386 8 4 7.77614 4 7.5V6.5C4 6.22386 4.22386 6 4.5 6ZM8.5 12H4.5C4.22386 12 4 11.7761 4 11.5V10.5C4 10.2239 4.22386 10 4.5 10H8.5C8.77614 10 9 10.2239 9 10.5V11.5C9 11.7761 8.77614 12 8.5 12Z",
    fill: "#EE7623"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingReview);
export default __webpack_public_path__ + "static/media/PendingReview.7feb9b54d8ca5e75c3757c0a1170e6e6.svg";
export { ForwardRef as ReactComponent };